export default {
  backgroundColor: Styles.color.grey.five,
  bannerBackgroundColor: Styles.color.white,
  clearButtonBackgroundColor: Styles.color.white,
  tabBackground: Styles.color.grey.five,
};
